<template>
    <div class="bg-white">
        <div class="p-5 md:py-12 xl:py-24 2xl:py-32 login-page border-b border-gray-200">
            <div class="mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <div class="faded border-gray-200 border p-4 rounded-t-lg">

                    <a href="#" class="flex-shrink-0 group block">
                        <div class="flex items-center">
                            <div>
                                <svg class="inline-block h-8 w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p :class="`font-medium text-${$root.theme}-400 group-hover:text-${$root.theme}-600`">
                                    Pay what you want, when you want!
                                </p>
                            </div>
                        </div>
                    </a>

                    <h1 class="font-semibold text-2xl mb-1 mt-2">Hello, {{ firstName }} {{ lastName }}</h1>
                    <p class="leading-tight" v-if="section === 'enter-payment-info'">Please enter your payment information below.</p>

                </div>
                <div v-if="section === 'enter-payment-info'" class="faded border-gray-200 border-b border-l border-r p-5 rounded-b-lg">

                    <form method="POST" @submit.prevent="confirmOffer">
                        <select v-model="form.type"
                                :id="`${unique}_payment_method`"
                                name="payment_method"
                                :class="`bg-gray-50 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 mt-1 block w-full pl-4 pr-10 py-3 text-base border-gray-300 focus:outline-none sm:text-sm rounded-md`">
                            <option :value="null">Choose Method:</option>
                            <option value="same" v-if="billingProfile && billingProfile.payment_type">
                                {{ billingProfile.payment_type === 'check' ? 'Checking' : billingProfile.cc_type }} ••••
                                {{ billingProfile.account_last_4 }}
                            </option>
                            <option v-if="$parent.settings.enable_ach" value="check">Pay with Personal Bank account</option>
                            <option value="card">Pay with Credit/Debit Card</option>
                        </select>

                        <pay-with-bank v-if="form.type === 'check'"
                            :first_name.sync="form.first_name"
                            :last_name.sync="form.last_name"
                            :routing_number.sync="form.routing_number"
                            :account_number.sync="form.account_number"
                            :error="error" class="mt-4" />

                        <pay-with-card v-else-if="form.type === 'card'"
                            :first_name.sync="form.first_name"
                            :last_name.sync="form.last_name"
                            :cc_number.sync="form.cc_number"
                            :card_exp.sync="form.card_exp"
                            :exp_month.sync="form.exp_month"
                            :exp_year.sync="form.exp_year"
                            :cvv.sync="form.cvv"
                            :zip.sync="form.zip"
                            :error="error"
                            :settings="$parent.settings" class="mt-4"
                            :cc-valid-status="ccValidStatus" />

                        <div class="mt-5">
                            <p v-if="error" class="mb-3 text-sm text-red-500 font-medium text-center">
                                {{ error }}
                            </p>

                            <button v-if="section === 'enter-payment-info'" type="submit" :class="`w-full justify-center text-black items-center inline-flex items-center px-3 text-lg pt-4 pb-3 border border-transparent shadow-sm leading-4 font-medium rounded-md bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-200`">
                                <svg class="-ml-0.5 mr-3 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
                                </svg>
                                Save Payment Information
                            </button>
                        </div>
                        <div class="mt-5">
                            <p class="text-xs leading-tight font-medium text-center">
                                If you have any questions, please feel free to reach us at <a :href="`tel:${$parent.consumerPortalNumber}`" style="white-space: nowrap;">{{ $parent.consumerPortalNumber }}</a>.
                            </p>
                        </div>
                    </form>
                </div>
                <div v-else class="faded border-gray-200 border-b border-l border-r p-5 rounded-b-lg text-center">
                    <h1 :class="`text-${$root.theme}-500 font-medium mb-2`">Your billing information has been submitted.</h1>

                    <p class="text-xs font-medium text-center">
                        If you have any questions, please feel free to reach us at <a :href="`tel:${$parent.consumerPortalNumber}`" style="white-space: nowrap;">{{ $parent.consumerPortalNumber }}</a>.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mixins from '../mixins';
    import PayWithCard from '../components/PaymentMethods/PayWithCard';
    import PayWithBank from '../components/PaymentMethods/PayWithBank';

    const basePayment = {
        token: '',

        payment_id: '',
        type: 'check',
        amount: null,
        payment_date: '',
        frequency: 'monthly',
        email: '',
        first_name: '',
        last_name: '',

        routing_number: '',
        account_number: '',

        cc_number: '',
        card_exp: '',
        exp_month: '',
        exp_year: '',
        cvv: '',
        zip: ''
    };

	export default {
        mixins: [Mixins],

        components: {
            PayWithBank,
            PayWithCard
        },

        props: ['firstName', 'lastName', 'token'],

		data() {
			return {
                unique: null,
			    error: null,
                billingProfile: null,
                section: 'enter-payment-info',
				form: null,
			}
		},

        computed: {
            ccValidStatus() {
                if (/[^0-9-\s]+/.test(this.form.cc_number)) return false;

                // The Luhn Algorithm. It's so pretty.
                var nCheck = 0,
                    nDigit = 0,
                    bEven = false;

                let value = this.form.cc_number.replace(/\D/g, "");

                for (var n = value.length - 1; n >= 0; n--) {
                    var cDigit = value.charAt(n),
                        nDigit = parseInt(cDigit, 10);

                    if (bEven) {
                        if ((nDigit *= 2) > 9) nDigit -= 9;
                    }

                    nCheck += nDigit;
                    bEven = !bEven;
                }

                return (nCheck % 10) == 0;
            },
        },

        /**
         * @returns {void}
         */
        created() {
            this.form = {...basePayment};
            this.form.first_name = this.firstName;
            this.form.last_name = this.lastName;
            this.form.token = this.token;

            this.unique = Math.floor(Math.random() * 100);

            if (! this.$parent.settings.enable_ach) {
                this.form.type = 'card';
            }
        },

        methods: {
            /**
             * Displays modal and asks them to confirm.
             *
             * @returns {void}
             */
            confirmOffer() {
                this.$root.$emit('confirm-payment-information');
            },

            /**
             * @param {Boolean} wasConfirmed
             * @returns {void}
             */
            confirmPaymentInformation(wasConfirmed) {
                if (! wasConfirmed) {
                    this.error = 'You must confirm to proceed.';

                    return;
                }

            	this.$root.$emit('loading');

                if (! this.checkCardType(this.form)) return null;

                this.$http.post(`${this.$parent.consumerPortalBaseUrl}/api/billing-profiles`, this.form).then(() => {
                	this.section = 'confirmation';
                }).catch(error => {
                    this.section = 'enter-payment-info';
                    this.error = error.body.message ? error.body.message : `There was an error. Try again or contact us at ${this.$parent.consumerPortalNumber}.`;
                }).finally(() => this.$root.$emit('loading'));
            },
        }
	}
</script>
